import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { buildPortalRedirectUrl, userBelongsOnCurrentPortal } from '../utils/portalAccess';

/**
 * Redirects authenticated users to the portal URL that matches their role.
 * Company Secretary → /companysecretary; IT Admin / Group CS → /groupcompanysecretary.
 */
const PortalGuard = ({ children }) => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    if (loading || !isAuthenticated || !user?.role) return;

    if (userBelongsOnCurrentPortal(user.role)) return;

    const target = buildPortalRedirectUrl(user, location.pathname, location.search);
    if (target) {
      const currentUrl = `${window.location.origin}${location.pathname}${location.search}`;
      if (target !== currentUrl) {
        setRedirecting(true);
        window.location.replace(target);
      }
    }
  }, [loading, isAuthenticated, user, location.pathname, location.search]);

  if (loading || redirecting) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isAuthenticated && user?.role && !userBelongsOnCurrentPortal(user.role)) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return children;
};

export default PortalGuard;
